export default "__VITE_ASSET__29172c4d__"